export const INVITATION_HEADERS = [
    'Code',
    'SingleUse',
    'RewardResources',
    'InvitationReward',
    'Popup',
    'RewardAction',
    'Segment',
    'PolicyHolder',
    'Cohort',
    'InvitationMethod',
    'Onboarding',
    'JoinChallenges'
]

export function csvEscape(value) {
    const text = value == null ? '' : String(value)
    if (/[",\n\r]/.test(text))
        return `"${text.replace(/"/g, '""')}"`
    return text
}

export function splitCsvLine(line) {
    const cols = []
    let current = ''
    let inQuotes = false
    for (let i = 0; i < line.length; i++) {
        const ch = line[i]
        if (inQuotes) {
            if (ch === '"') {
                if (line[i + 1] === '"') {
                    current += '"'
                    i++
                } else {
                    inQuotes = false
                }
            } else {
                current += ch
            }
        } else if (ch === '"') {
            inQuotes = true
        } else if (ch === ',') {
            cols.push(current)
            current = ''
        } else {
            current += ch
        }
    }
    cols.push(current)
    return cols
}

export function parseCsvObjects(csvText, headerToken) {
    if (!csvText || !String(csvText).trim())
        return []
    const lines = String(csvText).replace(/\r\n/g, '\n').split('\n').filter((line) => line.trim())
    if (!lines.length)
        return []
    const first = splitCsvLine(lines[0].replace(/^\uFEFF/, '')).map((col) => col.trim())
    const hasHeader = first[0] && first[0].replace(/^"|"$/g, '').toLowerCase() === headerToken.toLowerCase()
    const headers = hasHeader ? first.map((h) => h.replace(/^"|"$/g, '')) : INVITATION_HEADERS
    const dataLines = hasHeader ? lines.slice(1) : lines
    return dataLines.map((line) => {
        const cols = splitCsvLine(line)
        const row = {}
        headers.forEach((header, i) => {
            row[header] = cols[i] != null ? String(cols[i]).trim() : ''
        })
        return row
    })
}

export function invitationFieldsToObject(fields) {
    return {
        Code: String(fields.code || '').trim(),
        SingleUse: fields.singleUse,
        RewardResources: fields.rewardResources,
        InvitationReward: fields.invitationReward,
        Popup: fields.popup,
        RewardAction: fields.rewardAction,
        Segment: fields.segment,
        PolicyHolder: fields.policyHolder,
        Cohort: fields.cohort,
        InvitationMethod: fields.invitationMethod,
        Onboarding: fields.onboarding,
        JoinChallenges: fields.joinChallenges
    }
}

export function serializeInvitationObjects(objects) {
    const rows = objects.map((obj) =>
        INVITATION_HEADERS.map((header) => csvEscape(obj[header] ?? '')).join(',')
    )
    return [INVITATION_HEADERS.join(','), ...rows].join('\n')
}

export function buildInvitationCsv(fields, csvText) {
    const objects = []
    if (fields?.code && String(fields.code).trim())
        objects.push(invitationFieldsToObject(fields))
    objects.push(...parseCsvObjects(csvText, 'Code'))
    if (!objects.length)
        return ''
    return serializeInvitationObjects(objects)
}

export function parseInvitationCsv(csvText) {
    if (!csvText)
        return []
    return parseCsvObjects(csvText, 'Code')
}
